import * as yup from "yup";

const createFaqValidator = yup
  .object({
    title: yup.string().required("Title is required"),
    description: yup.string().required("Description is required"),
    type: yup
      .string()
      .required("Type is required")
      .oneOf(["driver", "passenger"]),
  })
  .required();

export default createFaqValidator;
